import { createReducer } from 'store/helpers';
import { SET_SHOW_BUG_REPORT_FORM } from 'store/actions/general';

const initialState = {
  showBugReportForm: false,
};

const setShowBugReportForm = (state, { showBugReportForm }) =>
  state.merge({ showBugReportForm });

const handlers = {
  [SET_SHOW_BUG_REPORT_FORM]: setShowBugReportForm,
};

export default createReducer(initialState, handlers);
